import { Component, computed, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@xanadu/service';
import { AuthSignal, CommonSignal } from '@xanadu/signal';
import { startWith } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginDialogComponent {
    private readonly router = inject(Router);
    private readonly authService = inject(AuthService);
    private readonly commonSignal = inject(CommonSignal);
    private readonly authSignal = inject(AuthSignal);
    private readonly dialogRef = inject(MatDialogRef<LoginDialogComponent>);

    formGroup: FormGroup = new FormGroup({});
    data: any = {};

    pendingLogin = false;

    metaEmail: any = { id: 'email', name: 'Email', info: 'Email address', mandatory: true };
    metaPass: any = { id: 'password', name: 'Password', info: 'Password' };

    readonly formStatus = toSignal(
        this.formGroup.statusChanges.pipe(
            startWith(this.formGroup.status)
        ),
        {
            initialValue: this.formGroup.status
        }
    );

    readonly loginDisabled = computed(() =>
        this.formStatus() !== 'VALID'
    );

    constructor() {
        effect(() => {
            this.commonSignal.httpError();

            this.pendingLogin = false;
        });
    }

    onSubmit() {
        this.pendingLogin = true;
        const credentials = this.formGroup.value;
        void this.login(credentials.email, credentials.password);
    }

    private async login(email: string, password: string) {
        firstValueFrom(this.authService.login(email, password))
            .then(() => {
                this.router.navigate(['/']);
                this.dialogRef.close();
                this.pendingLogin = false;
            });
    }
}
